import * as React from 'react';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

/**
 *
 * @deprecated
 *
 * use DndProvider instead (probably at (or close to) the root the app)
 */
export function dndContextWrapper<P>(Comp: React.ComponentType<P>) {
  return (props: React.PropsWithChildren<P>) => (
    <DndProvider backend={HTML5Backend}>
      <Comp {...props} />
    </DndProvider>
  );
}
